import styled from 'styled-components';

export const Button = styled.button`
  display: inline-block;
  padding: ${({ small }) => (small ? '0.5rem 1rem' : '0.75rem 1.5rem')};
  font-size: ${({ small }) => (small ? '0.9rem' : '1rem')};
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: ${({ secondary, theme }) => 
    secondary ? theme.colors.accent : theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  transition: all ${({ theme }) => theme.transitions.standard};
  box-shadow: ${({ theme }) => theme.shadows.small};
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.medium};
    background-color: ${({ secondary, theme }) => 
      secondary ? '#0095cc' : '#e04a18'};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: ${({ small }) => (small ? '0.4rem 0.8rem' : '0.6rem 1.2rem')};
    font-size: ${({ small }) => (small ? '0.8rem' : '0.9rem')};
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: ${({ theme, light }) => light ? theme.colors.white : theme.colors.secondary};
  text-align: ${({ center }) => (center ? 'center' : 'left')};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2rem;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.75rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.25rem;
  font-weight: 400;
  margin-bottom: 2rem;
  color: ${({ theme, light }) => light ? theme.colors.white : theme.colors.darkGray};
  text-align: ${({ center }) => (center ? 'center' : 'left')};
  max-width: ${({ maxWidth }) => maxWidth || '800px'};
  margin-left: ${({ center }) => (center ? 'auto' : '0')};
  margin-right: ${({ center }) => (center ? 'auto' : '0')};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.1rem;
  }
`;

export const Section = styled.section`
  padding: 5rem 0;
  background-color: ${({ theme, dark, accent }) => 
    dark ? theme.colors.secondary : 
    accent ? theme.colors.accent : theme.colors.white};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 4rem 0;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 3rem 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0 1rem;
  }
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  justify-content: ${({ justify }) => justify || 'flex-start'};
  align-items: ${({ align }) => align || 'flex-start'};
  flex-wrap: ${({ wrap }) => wrap || 'nowrap'};
  gap: ${({ gap }) => gap || '0'};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: ${({ mobileDirection }) => mobileDirection || 'column'};
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns || 3}, 1fr);
  gap: ${({ gap }) => gap || '2rem'};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    grid-template-columns: repeat(${({ tabletColumns }) => tabletColumns || 2}, 1fr);
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: repeat(${({ mobileColumns }) => mobileColumns || 1}, 1fr);
  }
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 2rem;
  box-shadow: ${({ theme }) => theme.shadows.medium};
  transition: all ${({ theme }) => theme.transitions.standard};
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: ${({ theme }) => theme.shadows.large};
  }
`;
